'use client'

import type { GalleryBlock } from '@onclicks/payload-types'
import { cn } from '@onclicks/utilities/ui'
import React from 'react'
import { CMSLink } from './CMSLink'
import { courierPrime, quicksand } from '@onclicks/utilities/fontImport'

/**
 * Barre horizontale de liens réutilisée partout où ce visuel apparaît
 * (ex. Notre Menu, Dégustation). Deux modes :
 * - `nav` : liens CMS classiques (chaque lien garde son `appearance`, "outline" par défaut
 *   pour retrouver le style déjà utilisé ailleurs, cf. MediumImpactHero/HighImpactHero).
 * - `tabs` : boutons pilotant un contenu affiché en dessous (ex. TabContentBlock), même
 *   visuel que l'`outline` de Button.tsx mais avec un état actif/inactif.
 */
type LinkBarProps =
  | {
      mode: 'nav'
      links: NonNullable<GalleryBlock['links']>
      className?: string
    }
  | {
      mode: 'tabs'
      items: { label: string }[]
      activeIndex: number
      onSelect: (index: number) => void
      className?: string
    }

export const LinkBar: React.FC<LinkBarProps> = (props) => {
  return (
    <ul className={cn('flex flex-wrap justify-center gap-x-28 gap-y-2', props.className)}>
      {props.mode === 'nav'
        ? props.links.map((entry, i) => (
            <li key={entry.id ?? i}>
              <CMSLink {...entry.link} className={quicksand.className} />
            </li>
          ))
        : props.items.map((tab, i) => (
            <li key={i}>
              <button
                type="button"
                onClick={() => props.onSelect(i)}
                className={`border-t-0 border-r-0 border-l-0 ${quicksand.className}`}
              >
                {tab.label}
              </button>
            </li>
          ))}
    </ul>
  )
}
